export default "__VITE_ASSET__1KJ0JbmE__"